import "./UserItem.css";
import React from "react";
import PropTypes from "prop-types";
import HeaderItem from "../../mixins/HeaderItem";
import autobind from "autobind-decorator";
import UserIcon from "./UserIcon";

class UserItem extends React.Component {
    static propTypes = {
        user: PropTypes.object.isRequired,
        isImpersonating: PropTypes.bool.isRequired,
        isSales: PropTypes.bool,
        isEmployer: PropTypes.bool
    };

    @autobind
    getLabel(user, isImpersonating) {
        let helloText = "Hi, Member";
        if (isImpersonating) {
            helloText = "Impersonating " + user.email;
        } else if (user && user.firstName && user.lastName) {
            helloText = user.firstName + " " + user.lastName;
        }
        return helloText;
    }

    render() {
        const { isImpersonating, user, isSales, isEmployer } = this.props;

        return (
            <button className="user-item-button" onClick={this.handleClick}>
                <UserIcon user={user} isImpersonating={isImpersonating} isSales={isSales} isEmployer={isEmployer} />
                <span className="user-name-label no-mouseflow">{this.getLabel(user, isImpersonating)}</span>
                <i className="icon-down-open" />
            </button>
        );
    }
}

export default HeaderItem(UserItem, "user-item");
